import { useQuery, useMutation } from '@tanstack/vue-query';
import { client } from '@/composables/api/generated/client.gen';
import {
  courseApiPublicEndpointsGetCoursesOptions,
  courseApiPublicEndpointsSignupToCourseMutation,
  supportApiPublicEndpointsCreateSupportMessageMutation,
} from '@/composables/api/generated/@tanstack/vue-query.gen';

export type CourseTypeTitle = 'bil';

export function useHaru() {
  const config = useRuntimeConfig();
  const csrfToken = useCookie('csrftoken');

  client.setConfig({
    baseUrl: config.public.elevApiBaseUrl,
    credentials: 'include',
  });

  client.interceptors.request.use((request) => {
    if (csrfToken.value) {
      request.headers.set('X-CSRFToken', csrfToken.value);
    }
    return request;
  });

  function getIdForCourseType(title: CourseTypeTitle): string {
    if (title === 'bil') {
      return config.public.bilCourseTypeId;
    }

    throw new Error('Unable to find id for CourseType', {
      cause: { title },
    });
  }

  function getCourses() {
    return useQuery(courseApiPublicEndpointsGetCoursesOptions());
  }

  function useSignupMutation() {
    return useMutation(courseApiPublicEndpointsSignupToCourseMutation());
  }

  function useCreateSupportMessageMutation() {
    return useMutation(supportApiPublicEndpointsCreateSupportMessageMutation());
  }

  return {
    getIdForCourseType,
    getCourses,
    useSignupMutation,
    useCreateSupportMessageMutation,
  };
}
